<template>
  <div>
    <b-sidebar
      id="sidebar-intent"
      ref="sidebarIntent"
      v-model="isShowSidebar"
      aria-labelledby="sidebar-intent-header"
      no-header
      right
      backdrop
      shadow
      @hidden="hide"
    >
      <template #default="{}">
        <div id="sidebar-intent-header" class="">
          <div class="d-flex m-3">
            <h3 class="font-weight-bold text-main-color my-auto">
              Create/Edit Intent
            </h3>

            <div class="language-filter d-flex my-auto ml-auto px-3">
              <b-button-group class="btn-language">
                <b-button
                  v-for="(button, index) in languageList"
                  :key="index"
                  :class="{ active: languageActiveId == button.id }"
                  @click="$emit('setLanguageAvtive', button.id)"
                  >{{ button.name }}</b-button
                >
              </b-button-group>
            </div>
          </div>
        </div>
        <div class="m-3">
          <IntentForm
            ref="intentForm"
            :form="form"
            :intentLevel="intentLevel"
            :v="v"
            :showAllKeyword="showAllKeyword"
            :languageActiveId="languageActiveId"
            :sentimentActiveId="sentimentActiveId"
            :isSentiment="isSentiment"
            v-bind:channelList="channelList"
            v-bind:tierList="tierList"
            v-on:setShowAllKeyword="setShowAllKeyword"
            v-on:setSentimentActive="setSentimentActive"
            v-on:setIsSentiment="setIsSentiment"
            v-on:onIntentTypeChange="onIntentTypeChange"
            v-on:onApiConfigChange="onApiConfigChange"
            v-on:onSetTeirChange="onSetTeirChange"
          />
        </div>
      </template>

      <template #footer>
        <div
          class="d-flex justify-content-between shadow align-items-center p-2"
        >
          <div class="w-100 p-2">
            <b-button
              block
              size="lg"
              variant="dark"
              class="text-light rounded-pill"
              @click="hide"
              >Cancel</b-button
            >
          </div>
          <div class="w-100 p-2">
            <b-button
              block
              size="lg"
              variant="light"
              class="text-body rounded-pill btn-main"
              @click="$emit('createOrUpdateIntent')"
            >
              Submit
            </b-button>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import IntentForm from "@/views/pages/flow-builder/components/sidebar/IntentForm";
export default {
  components: {
    IntentForm,
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    v: {
      required: true,
      type: Object,
    },
    languageActiveId: {
      required: false,
      type: Number,
    },
    channelList: {
      required: true,
      type: Array,
    },
    tierList: {
      required: true,
      type: Array,
    },
    sentimentActiveId: {
      required: false,
      type: Number,
    },
    isSentiment: {
      required: false,
      type: Boolean,
    },
    intentLevel: {
      required: false,
      type: Number,
    },
    languageList: {
      required: false,
      type: Array,
    },
  },
  data() {
    return {
      isShowSidebar: false,
      showAllKeyword: false,
      isDisplyTH: true,
      isDisplyEN: true,
      forceRefresh: true,
    };
  },
  created () {
  },
  methods: {
    onIntentTypeChange(val) {
      this.$emit("onIntentTypeChange", val);
    },
    onApiConfigChange(val) {
      this.$emit("onApiConfigChange", val);
    },
    onSetTeirChange(val) {
      this.$emit("onSetTeirChange", val);
    },
    checkDisplyLanguage() {
      if (this.mainIntent) {
        this.mainIntent.intent.forEach((intent) => {
          if (intent.language == 1) {
            if (intent.keyword.lenght == 0) {
              this.isDisplyTH = false;
            } else if (!intent.name) {
              this.isDisplyTH = false;
            } else {
              this.isDisplyTH = true;
            }
          }
          if (intent.language == 2) {
            if (intent.keyword.lenght == 0) {
              this.isDisplyEN = false;
            } else if (!intent.name) {
              this.isDisplyEN = false;
            } else {
              this.isDisplyEN = true;
            }
          }
        });
      }
    },
    setIsSentiment() {
      this.$emit("setIsSentiment");
    },
    setSentimentActive(val) {
      this.$emit("setSentimentActive", val);
    },
    setShowAllKeyword() {
      this.showAllKeyword = !this.showAllKeyword;
    },
    handleForcefresh() {
      this.forceRefresh = false;
      this.$nextTick(() => {
        this.forceRefresh = true;
      });
    },
    show() {
      this.$refs.intentForm.onRefreshForm();
      this.showAllKeyword = false;
      this.isShowSidebar = true;
    },
    hide() {
      this.isShowSidebar = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .b-sidebar {
  width: 450px;
}
.text-main-color {
  color: #242424;
}
.text-soft-grey {
  color: #bebebe;
}
.main-color {
  background-color: #242424;
  color: white !important;
}
.border-radius-0 {
  border-radius: 0px;
}
@media (max-width: 767.98px) {
  ::v-deep .b-sidebar {
    width: 100%;
  }
}
</style>
